import React, { Component } from 'react'

import "../css/admin/AdminUsuarios.css";
import check from "../assets/check.svg";
import checkGreen from "../assets/check.png";
import changeView from "../assets/eye-fill.svg";
import equis from "../assets/eliminar.svg"
import SideBar from './adminComponents/SideBar';
import ModalFirmas from './adminComponents/ModalFirmas';
import HeaderAdmin from './adminComponents/HeaderAdmin';
import NavBarInfo from './adminComponents/NavBarInfo';
import Modal from './components/Modal';
import { ComponenteSpinner } from './adminComponents/ComponenteSpinner';
import { Navigate } from 'react-router-dom';
import axios from "axios";
/*import MaterialTable from "material-table";*/
import MaterialTableAdmin from './components/MaterialTableAdmin';
import Cookies from 'js-cookie';
import ModalAdminMensaje from './adminComponents/ModalAdminMensaje';
import jwt from 'jwt-decode'
import Visualizarpdf from "./components/Visualizarpdf";
import ModalXL from './components/ModalXL';
import Face from '@material-ui/icons/Face'
import BrandingWatermark from '@material-ui/icons/BrandingWatermark'
import Description from '@material-ui/icons/Description';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { memo } from 'react';



export class AdminHabilitarFirmas extends Component {
    constructor(props) {
        super(props);

        this.state = {
            valor_fitro: "no revisado",
            motivo: "",
            showmodalCopy: false,
            ModalFirmasIsOpen: false,
            modalExitoso: {
                show: false,
                titulo: "",
                mensaje: ""
            },
            vistaImg: true,
            solicitudes: [],
            firmas: [],
            datosUsuario: {
                nombres: "",
                apellidos: "",
                identificacion: "",
                rol: ""
            },
            columnas: [
                {
                    title: "#",
                    field: "idpersona",
                    render: rowData => {
                        // rowData.tableData.id es el índice del array (0, 1, 2...)
                        // Le sumamos 1 para que visualmente empiece en 1
                        return rowData.tableData.id + 1;
                    }
                },{
                    title: "Usuario",
                    field: "email",
                    render: rowData => {
                        // rowData.tableData.id es el índice del array (0, 1, 2...)
                        // Le sumamos 1 para que visualmente empiece en 1
                        return rowData.email.split("@")[0];
                    }
                },
                {
                    title: "Nombres",
                    field: "nombres",
                    render: rowData => {
                        return (`${rowData.nombres}`)
                    },
                }, {
                    title: "Apellidos",
                    field: "apellidos",
                    render: rowData => {
                        return (`${rowData.apellidos}`)
                    },
                },
                {
                    title: "Identificacion",
                    field: "numeroidentificacion",

                },
                {
                    title: `# firmas  ${new Date().getFullYear()}`,
                    field: "firmas",
                    render: rowData => {
                        const currentYear = new Date().getFullYear();
                        if (!rowData.firmas || !Array.isArray(rowData.firmas)) {
                            return 0;
                        }
                        const cantidad = rowData.firmas.filter(firma => {
                            const anioFirma = new Date(firma.fechaEmision).getFullYear();
                            return anioFirma === currentYear;
                        }).length;
                        return cantidad;
                    }
                }
            ],
            acciones: [
                rowData => ({
                    icon: 'visibility',
                    iconProps: { style: { color: "#767E9F" } },
                    onClick: (event, rowData) => this.abrirModalVerFirmas(rowData)
                })
            ],
            verSolicitud: {
                id: 0,
                nombres: "",
                correo: "",
                actividad: "",
                unidad: "",
                telefono: "",
                usuario_sugerido: "",
                alias_sugerido: "",

                idpersona: "",
                identifiacion: "",
                nombres: "",
                apellidos: "",
                firmas: [],
                correo: "",
                estado: "",
            },
            loading: true,
            loading_spinner_btn:false,
            cerrarSesion: false,
            modalMensaje: false,
            mensajerechazo: "",
            showImgAcuerdo: "",
            modalshowPdf: {
                show: false,
                srcPdf: "",
            },
            IsValid: {
                isValidRostro: 1,
                isValidCedula: 1,
                isValidAcuerdo: 1
            },
            activebuttonAcept: true,
            tipoArchivoCedula: "imagen",
        };

        this.abrirModalVerFirmas = this.abrirModalVerFirmas.bind(this);
        this.cerrarModalVerFirmas = this.cerrarModalVerFirmas.bind(this);

        this.activebuttonAcept = this.activebuttonAcept.bind(this);
        this.disabledbuttonAcept = this.disabledbuttonAcept.bind(this);

        this.abrirModalExitoso = this.abrirModalExitoso.bind(this);
        this.cerrarModalExitoso = this.cerrarModalExitoso.bind(this);
    }

    componentDidMount() {
        var token = Cookies.get("token");
        var tokendecode = jwt(token);
        this.state.datosUsuario.nombres = tokendecode["Nombres"];
        this.state.datosUsuario.apellidos = tokendecode["Apellidos"];
        this.state.datosUsuario.rol = tokendecode["Rol"];
        if (this.state.datosUsuario.rol != "Admin") {
            window.location.href = "/inicio"
        }
        this.setState({
            datosUsuario: {
                nombres: tokendecode["Nombres"],
                apellidos: tokendecode["Apellidos"],
            }
        });
        this.setearHeader();
        this.getPersonasFirmas();

    }

    getPersonasFirmas = async () => {
        await axios.get(`${process.env.REACT_APP_API}api/Firmas/getpersonasfirmas`)
            .then(response => {
                //console.log(response);
                this.setState({
                    solicitudes: response.data.result,
                    loading: false
                }, () => {
                    // console.log(this.state.solicitudes)
                });
            })
    }



    traerDatosFirmas = async (rowData) => {
        const estadoRenovacion = await this.validarRenovacionFirma(rowData.email);
        await this.setState({
            verSolicitud: {
                ...this.state.verSolicitud,
                idpersona: rowData.idpersona,
                identifiacion: rowData.numeroidentificacion,
                nombres: rowData.nombres,
                apellidos: rowData.apellidos,
                firmas: rowData.firmas,
                correo: rowData.email,
                estado: estadoRenovacion
            }
        });
    }
    validarRenovacionFirma = async (email) => {
        try {
            var username_temp = email.split("@")[0];
            const response = await axios.get(`${process.env.REACT_APP_API_FIRMAS}/FirmaElectronica/ValidarRenovacionDeFirmasByIdPersona/${username_temp}`)
            return response.data.data.habilitadoRenovar;
        } catch (error) {
            return "Error";
        }
    }
    abrirModalVerFirmas(rowData) {
        this.setState({ ModalFirmasIsOpen: true });
        this.traerDatosFirmas(rowData)
    }
    cerrarModalVerFirmas() {
        this.setState({ ModalFirmasIsOpen: false });
    }

    habilitarCreacionFirma = async () => {
        this.setState({
            loading_spinner_btn:true,
        })
        console.log("habilitarCreacionFirma");
        const fechaFinTemp = new Date();
        fechaFinTemp.setDate(fechaFinTemp.getDate() + 7);
        var TFelApRenovacion = {
            idPersona: this.state.verSolicitud.idpersona,
            estado: "A",
            fechaFin: fechaFinTemp,
            fechaCreacion: new Date(),
        }
        await axios.post(`${process.env.REACT_APP_API}api/Firmas/habilitarcreacionfirmas`, TFelApRenovacion)
            .then(resp => {
                console.log(resp);
                console.log(resp.data);
                console.log(resp.data.success);
                var imagen_temp = "";
                var titulo_temp = "";
                var mensaje_temp = "";
                if (resp.data.success) {
                    imagen_temp = checkGreen;
                    titulo_temp = "Exito";
                    mensaje_temp = `Se habilitó a ${this.state.verSolicitud.nombres} ${this.state.verSolicitud.apellidos} para crear su firma electrónica.`;
                } else {
                    imagen_temp = equis;
                    titulo_temp = "Error";
                    mensaje_temp = resp.data.message;
                }
                this.cerrarModalVerFirmas();
                this.setState({
                    modalExitoso: {
                        show: true,
                        imagen: imagen_temp,
                        titulo: titulo_temp,
                        mensaje: mensaje_temp
                    },
                    loading_spinner_btn:false,
                })
            }).catch(error => {
                this.disabledbuttonAcept();
                this.setState({
                    modalExitoso: {
                        show: true,
                        imagen: equis,
                        titulo: "Error",
                        mensaje: `Ocurrio un error en el servidor, intente más tarde.`
                    }
                })
            })
    }

    activebuttonAcept() {
        this.setState({ activebuttonAcept: true });
    }

    disabledbuttonAcept() {
        this.setState({ activebuttonAcept: false });
    }

    cerrarSesion = async () => {
        this.props.setValue(false);
        Cookies.remove("nombres");
        Cookies.remove("apellidos");
        Cookies.remove("identificacion");
        Cookies.remove("token");
        Cookies.remove("cas");

        Cookies.remove("rol");
        Cookies.remove("username");
        Cookies.remove("DatosPersonalesGIA.CAS");
        Cookies.remove("id");
        Cookies.remove("correoAlterno");
        Cookies.remove("Nombre");

        window.location.href = "/logout"
        this.setState({ cerrarSesion: true });
        //  console.log("cerrando sesion");
    }


    setearHeader() {
        var token = Cookies.get("token")
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        } else {
            axios.defaults.headers.common['Authorization'] = null;
        }
    }

    abrirModalExitoso() {
        this.setState({
            modalExitoso: {
                ...this.state.modalExitoso,
                show: true
            }
        });
    }

    cerrarModalExitoso() {
        this.setState({
            modalExitoso: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        });
       // console.log("cerrar modal " + this.state.modalExitoso);
    }

    render() {
        var nombresCompletos = `${this.state.datosUsuario.nombres} ${this.state.datosUsuario.apellidos}`
        return (
            this.state.cerrarSesion ? <Navigate to="/Inicio" /> :
                this.state.loading ?
                    <ComponenteSpinner></ComponenteSpinner> :
                    (<div id="admin-fondo">
                        <HeaderAdmin nombresCompletos={nombresCompletos}></HeaderAdmin>
                        <NavBarInfo cerrarSesion={this.cerrarSesion}></NavBarInfo>
                        <div className='row adminUsers-body'>
                            <SideBar nombres={nombresCompletos} tipo={"habilitarfirma"}></SideBar>
                            <div className='col-md-9 mt-4'>
                                <p className='admin-titulo'>Habilitar firma electrónica ESPOL</p>
                                <MaterialTableAdmin
                                    columns={this.state.columnas}
                                    data={this.state.solicitudes}
                                    actions={this.state.acciones}
                                > </MaterialTableAdmin>
                            </div>
                        </div>


                        {this.state.ModalFirmasIsOpen &&
                            <ModalFirmas
                                isOpen={this.state.ModalFirmasIsOpen}
                                cerrarModal={this.cerrarModalVerFirmas}
                                tituloHeader={`Firmas de ${this.state.verSolicitud.nombres} ${this.state.verSolicitud.apellidos}`}
                                submit={this.habilitarCreacionFirma}
                                txtBtnSubmit={"Habilitar creación"}
                                estado={this.state.verSolicitud.estado}
                                loading_spinner_btn={this.state.loading_spinner_btn}
                            >
                                <div className="row mt-2">
                                    <div className="col-12">
                                        {this.state.verSolicitud.firmas && this.state.verSolicitud.firmas.length > 0 ? (
                                            <div className="table-responsive">
                                                <table className="table table-bordered table-striped table-hover">
                                                    <thead className="thead-dark">
                                                        <tr>
                                                            <th>ID</th>
                                                            <th>Fecha Emisión</th>
                                                            <th>Fecha Vencimiento</th>
                                                            <th>Estado</th>
                                                            <th>TC</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.verSolicitud.firmas.map((firma, index) => (
                                                            <tr key={firma.idFelFirmaElect || index}>
                                                                <td>{firma.idFelFirmaElect}</td>
                                                                <td>
                                                                    {firma.fechaEmision
                                                                        ? new Date(firma.fechaEmision).toLocaleString()
                                                                        : '-'}
                                                                </td>
                                                                <td>
                                                                    {firma.fechaVencimiento
                                                                        ? new Date(firma.fechaVencimiento).toLocaleDateString()
                                                                        : '-'}
                                                                </td>
                                                                <td>
                                                                    {firma.estado === 'A' ? (
                                                                        <span className="badge activo">Activa</span>
                                                                    ) : firma.estado === 'I' ? (
                                                                        <span className="badge inactivo">Inactiva</span>
                                                                    ) : (
                                                                        firma.estado
                                                                    )}
                                                                </td>
                                                                <td>{firma.aceptaTc}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <div className="alert alert-warning text-center">
                                                No se encontraron firmas registradas para esta solicitud.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </ModalFirmas>
                        }

                        {this.state.modalExitoso.show &&
                            <Modal isOpen={this.state.modalExitoso.show} cerrarModal={this.cerrarModalExitoso} verBoton={true} textoBoton="ACEPTAR" >
                                <p className='text-center'><strong>{this.state.modalExitoso.titulo}</strong></p>
                                <div className='mt-6 mb-6' align="center">
                                    <img className="registroContra-check" src={this.state.modalExitoso.imagen} alt="Exitoso"></img>
                                </div>

                                <p className='text-center'>{this.state.modalExitoso.mensaje}</p>
                            </Modal>
                        }
                    </div>)
        )
    }
}

export default memo(AdminHabilitarFirmas)
